import * as types from './constants'

export const getUserCreatedEvents = (state = {
  isRequesting: false,
}, action) => {
  switch (action.type) {
    case types.GET_USER_CREATED_EVENTS.request:
      return {
        ...state,
        isRequesting: true,
      }
    case types.GET_USER_CREATED_EVENTS.success:
      return {
        ...state,
        isRequesting: false,
        data: action.result.result,
      }
    case types.GET_USER_CREATED_EVENTS.failed:
      return {
        ...state,
        isRequesting: false,
        error: action.error,
      }
    default:
      return state
  }
}

export const getUserCreatedInfos = (state = {
  isRequesting: false,
}, action) => {
  switch (action.type) {
    case types.GET_USER_CREATED_INFOS.request:
      return {
        ...state,
        isRequesting: true,
      }
    case types.GET_USER_CREATED_INFOS.success:
      return {
        ...state,
        isRequesting: false,
        data: action.result.result,
      }
    case types.GET_USER_CREATED_INFOS.failed:
      return {
        ...state,
        isRequesting: false,
        error: action.error,
      }
    default:
      return state
  }
}

export const getUserCreatedProducts = (state = {
  isRequesting: false,
}, action) => {
  switch (action.type) {
    case types.GET_USER_CREATED_PRODUCTS.request:
      return {
        ...state,
        isRequesting: true,
      }
    case types.GET_USER_CREATED_PRODUCTS.success:
      return {
        ...state,
        isRequesting: false,
        data: action.result.result,
      }
    case types.GET_USER_CREATED_PRODUCTS.failed:
      return {
        ...state,
        isRequesting: false,
        error: action.error,
      }
    default:
      return state
  }
}

export const getFavoriteProducts = (state = {
  isRequesting: false,
}, action) => {
  switch (action.type) {
    case types.GET_FAVORITE_PRODUCTS.request:
      return {
        ...state,
        isRequesting: true,
      }
    case types.GET_FAVORITE_PRODUCTS.success:
      return {
        ...state,
        isRequesting: false,
        data: action.result.result,
      }
    case types.GET_FAVORITE_PRODUCTS.failed:
      return {
        ...state,
        isRequesting: false,
        error: action.error,
      }
    default:
      return state
  }
}

export const getFavoriteInfos = (state = {
  isRequesting: false,
}, action) => {
  switch (action.type) {
    case types.GET_FAVORITE_INFOS.request:
      return {
        ...state,
        isRequesting: true,
      }
    case types.GET_FAVORITE_INFOS.success:
      return {
        ...state,
        isRequesting: false,
        data: action.result.result,
      }
    case types.GET_FAVORITE_INFOS.failed:
      return {
        ...state,
        isRequesting: false,
        error: action.error,
      }
    default:
      return state
  }
}

export const getFavoriteEvents = (state = {
  isRequesting: false,
}, action) => {
  switch (action.type) {
    case types.GET_FAVORITE_EVENTS.request:
      return {
        ...state,
        isRequesting: true,
      }
    case types.GET_FAVORITE_EVENTS.success:
      return {
        ...state,
        isRequesting: false,
        data: action.result.result,
      }
    case types.GET_FAVORITE_EVENTS.failed:
      return {
        ...state,
        isRequesting: false,
        error: action.error,
      }
    default:
      return state
  }
}

export const createProduct = (state = {
  isRequesting: false,
}, action) => {
  switch (action.type) {
    case types.CREATE_PRODUCT.request:
      return {
        ...state,
        isRequesting: true,
        error: undefined,
      }
    case types.CREATE_PRODUCT.success:
      return {
        ...state,
        isRequesting: false,
        data: action.result.result,
      }
    case types.CREATE_PRODUCT.failed:
      return {
        ...state,
        isRequesting: false,
        error: action.error.errors,
      }
    default:
      return state
  }
}

export const createEventMina = (state = {
  isRequesting: false,
}, action) => {
  switch (action.type) {
    case types.CREATE_EVENT.request:
      return {
        ...state,
        isRequesting: true,
        error: undefined,
      }
    case types.CREATE_EVENT.success:
      return {
        ...state,
        isRequesting: false,
        data: action.result.result,
      }
    case types.CREATE_EVENT.failed:
      return {
        ...state,
        isRequesting: false,
        error: action.error.errors,
      }
    default:
      return state
  }
}

export const createInfoMina = (state = {
  isRequesting: false,
}, action) => {
  switch (action.type) {
    case types.CREATE_INFO.request:
      return {
        ...state,
        isRequesting: true,
        error: undefined,
        data: undefined,
        message: undefined,
      }
    case types.CREATE_INFO.success:
      return {
        ...state,
        isRequesting: false,
        data: action.result.result,
        message: action.result.message,
      }
    case types.CREATE_INFO.failed:
      return {
        ...state,
        isRequesting: false,
        error: action.error.errors,
      }
    default:
      return state
  }
}

export const getNotification = (state = {
  isRequesting: false,
}, action) => {
  switch (action.type) {
    case types.GET_NOTIFICATION.request:
      return {
        ...state,
        isRequesting: true,
      }
    case types.GET_NOTIFICATION.success:
      return {
        ...state,
        isRequesting: false,
        data: action.result.result,
      }
    case types.GET_NOTIFICATION.failed:
      return {
        ...state,
        isRequesting: false,
        error: action.error,
      }
    default:
      return state
  }
}

export const getEvent = (state = {
  isRequesting: false,
}, action) => {
  switch (action.type) {
    case types.GET_EVENT.request:
      return {
        ...state,
        isRequesting: true,
      }
    case types.GET_EVENT.success:
      return {
        ...state,
        isRequesting: false,
        data: action.result,
      }
    case types.GET_EVENT.failed:
      return {
        ...state,
        isRequesting: false,
        error: action.error,
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/modules/Profile/reducers.js